export interface Theme {
  key: ThemeType;
  name: string;
}

export enum ThemeType {
  DefaultTheme = 'default-theme',
  LightTheme = 'light-theme',
}
